import { axiosInstanceConversationalEngine } from "../instance";

export interface DropiDepartment {
  id: number;
  name: string;
  country_id?: number;
  department_code?: string | null;
}

export interface DropiCity {
  id: number;
  department_id: number;
  name: string;
  rate_type?: string;
  trajectory_type?: string;
  cod_dane?: string;
  zip_code?: string | null;
}

export const getDropiDepartments = async (
  country: string
): Promise<DropiDepartment[]> => {
  const response = await axiosInstanceConversationalEngine.get(
    "/integration/dropi/departments",
    { params: { country } }
  );
  return response.data;
};

export const getDropiCitiesByDepartmentId = async (
  departmentId: number,
  country: string
): Promise<DropiCity[]> => {
  const response = await axiosInstanceConversationalEngine.get(
    `/integration/dropi/departments/${departmentId}/cities`,
    { params: { country } }
  );
  return response.data;
};
